import { FinanceData } from "./types";
import { createSampleData } from "./sampleData";

// The UI only talks to this interface. The demo stores data in the browser;
// a real version can implement the same interface on top of an API.
export interface FinanceRepository {
    load(): FinanceData;
    save(data: FinanceData): void;
    reset(): FinanceData;
}

const STORAGE_KEY = "sts-finance-tracker";

export class LocalStorageRepository implements FinanceRepository {
    load(): FinanceData {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw) {
                const data = JSON.parse(raw) as FinanceData;
                if (data.version === 1 && Array.isArray(data.transactions)) {
                    return data;
                }
            }
        } catch (e) {
            // Storage unavailable or corrupted - fall back to sample data
        }
        return createSampleData();
    }

    save(data: FinanceData): void {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {
            // Ignore - in the demo, persistence is a convenience only
        }
    }

    reset(): FinanceData {
        const data = createSampleData();
        this.save(data);
        return data;
    }
}
